import { ArrowUpRight } from 'lucide-react'
import s from '../styles/landing.module.css'

export function EditorialFooter() {
  return <footer className={s.footer}>
    <span>Muhasebe AI</span>
    <p>Geçmişin özeni. Geleceğin imkânları.</p>
    <a href="/kvkk">KVKK Aydınlatma Metni</a>
    <a href="/sozlesme">Kullanım Koşulları</a>
    <a href="https://wa.me/905306334666" target="_blank" rel="noopener noreferrer">İletişim <ArrowUpRight size={15} /></a>
    <a href="#top">Başa dön <ArrowUpRight size={15} /></a>
  </footer>
}
